export default __webpack_public_path__ + "static/media/zukunf_lauft_l2.74fdaf30.png";